export default "__VITE_ASSET__57d8c68f__"